(function (angular) {
  "use strict";

  angular.module("app").service("ForumSearchApi", forumSearch);

  forumSearch.$inject = ["$resource", "extendResource", "settings"];

  function forumSearch($resource, extendResource, settings) {
    var resource = $resource(settings.apiBase + "/forum/search?q=:query", {
      query: "@query",
    });
    return extendResource(resource);
  }
})(angular);
